exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2ZMzSo3tw3RMLKE5JdKmO8{position:relative;top:0px;left:9px}\n", ""]);

// Exports
exports.locals = {
	"settingsPosition": "_2ZMzSo3tw3RMLKE5JdKmO8"
};